import ismobileviewport from '../../js/modules/mt-ismobileviewport.js'

export default function () {
  $(document).ready(function () {
    var navbar = $('.sitenavbar__nav').first()

    $('.sitenavbar').each(function () {
      let bar = $(this),
        mobBtn = bar.find('.sitenavbar__toggle'),
        nav = bar.find('.sitenavbar__nav'),
        htmlElem = $('html')

      // setup classes
      bar.addClass('js-mobilehidden')

      // react to events on button
      mobBtn.click(function () {
        if (bar.hasClass('js-mobilehidden')) {
          bar.addClass('js-mobiletransition')
          // Do this next bit just a split second (1 millisecond) after the class in the line above has been added. If we try to do this all instantly then the CSS doesn't have time to prep the animation and it just skips it completely.
          setTimeout(function () {
            bar.removeClass('js-mobilehidden')
            bar.addClass('js-mobilevisible')
            htmlElem.addClass('noscroll')
          }, 1)
          // do this next part to clean up the animation classes after the animation is PROBABLY complete (a few hundred milliseconds)
          setTimeout(function () {
            bar.removeClass('js-mobiletransition')
          }, 400)
        } else {
          bar.addClass('js-mobiletransition')
          // Do this next bit just a split second (1 millisecond) after the class in the line above has been added. If we try to do this all instantly then the CSS doesn't have time to prep the animation and it just skips it completely.
          setTimeout(function () {
            bar.removeClass('js-mobilevisible')
            bar.addClass('js-mobilehidden')
            htmlElem.removeClass('noscroll')
          }, 1)
          // do this next part to clean up the animation classes after the animation is PROBABLY complete (a few hundred milliseconds)
          setTimeout(function () {
            bar.removeClass('js-mobiletransition')
          }, 400)
        }
      })
    })

    let sitenav = {
      sitenavbar: $('.sitenavbar'),
      nav: $('.sitenavbar').find('.nav').first(),
      form: $('.sitenavbar').find('.searchexpandable').first(),
      search: $('.sitenavbar').find('.searchexpandable__search').first(),
      submit: $('.sitenavbar').find('.searchexpandable__submit').first(),
      isopen: false,
      openExpSearch: function () {
        this.isopen = true

        this.sitenavbar.addClass('searchexpandable-is-open')
          // this.form.addClass('searchexpandable-is-open')
        this.sitenavbar.removeClass('searchexpandable-is-closed')
          // this.form.removeClass('searchexpandable-is-closed')
        this.search.focus()

        if (!ismobileviewport()) {
          // THESE LINES BREAK THE MEGAMENU STYLES this.nav.css({ 'opacity': '0', 'transform': 'translateX(-2em)' })
        }
      },
      closeExpSearch: function () {
        this.isopen = false

        this.sitenavbar.addClass('searchexpandable-is-closed')
          // this.form.addClass('searchexpandable-is-closed')
        this.sitenavbar.removeClass('searchexpandable-is-open')
          // this.form.removeClass('searchexpandable-is-open')
        this.search.blur()
        this.submit.blur()

        // We're using a library called hyperform to polyfill the require attribute
        // Because this form collapses and hyperform isn't aware of this it leaves its error messages in the DOM
        // this next line is just to remove them when the form collapses away
        this.sitenavbar.find('.hf-warning').remove()

        if (!ismobileviewport()) {
          // THESE LINES BREAK THE MEGAMENU STYLES this.nav.css({ 'opacity': '1', 'transform': 'translateX(0)' })
        }
      },
      toggleExpSearch: function (type) {
        if (this.isopen) {
          this.closeExpSearch()
        } else {
          this.openExpSearch()
        }
      }
    }
    $('html').on('click touchstart', function (event) {
      var target = $(event.target)[0]
      if (!sitenav.isopen) {
        if ($.contains(sitenav.form[0], target)) {
          sitenav.openExpSearch()
        }
      } else if (sitenav.isopen) {
        if (!$.contains(sitenav.form[0], target)) {
          sitenav.closeExpSearch()
        }
      }
    })

    // sitenav.search.focusout(function (event) {
    //   console.log('sitenav.isopen: ', sitenav.isopen)
    //   console.log(event, event.relatedTarget)
    //   if (sitenav.isopen) {
    //     // We need to give a few miliseconds before closing the search in case someone is trying to hit the 'Search' submit button
    //     setTimeout(function () {
    //       // console.log(sitenav.submit.is(':hover'))
    //       if (event.relatedTarget != sitenav.submit) {
    //         sitenav.closeExpSearch()
    //       }
    //     }, 150)
    //   }
    // })

    // if (ismobileviewport()) {

    navbar.find('li ul').parent().prepend('<button class="togglesubnav is-closed"><span class="screen-reader-text">open sub-nav</span></button>')

    var allbuttons = navbar.find('.togglesubnav'),
      allsublists = allbuttons.parent().children('ul')

    navbar.find('.togglesubnav').each(function () {
      var button = $(this),
        sublist = button.parent().children('ul')

      // sublist.css('display', 'none')
      button.click(function () {
        button.toggleClass('is-closed is-open')
        sublist.slideToggle()
      })
    })

      // reset everything if the mobile nav is closed
      // $('.sitenavbar__toggle').click(function () {
      //   allsublists.css('display', '')
      //   allbuttons.removeClass('is-open').addClass('is-closed')
      // })
    // }
  })

  // Attempt to make dropdown links not navigate on first tap on touch devices
  // navigate on second tap to allow access to the dropdown menu
  $(document).ready(function () {
    var topMegaMenuLinks = $('.sitenavbar__nav > ul > li.has-megamenu > a')

    topMegaMenuLinks.on('touchstart', function (e) {
      if (!ismobileviewport()) {
        e.preventDefault()
        e.stopPropagation()
        var hreflink = $(this).attr('href')
        if (!$(this).hasClass('tapped_once')) {
          // clear all the tapped_once classes from the topMegaMenuLinks
          $('.sitenavbar__nav > ul > li.has-megamenu > a.tapped_once').removeClass('tapped_once')
          // add the tapped_once class to this link, for use if this link is tapped again.
          $(this).addClass('tapped_once')
          return false
        } else {
          // if it does already have the tapped_once class than navigate the page
          window.location.href = hreflink
        }
      }
    })

    // if anywhere on the screen is tapped then close the megamenu
    $(window).on('touchstart', function () {
      // console.log('windowclick')
      window.setTimeout(function () {
        $('.sitenavbar__nav > ul > li.has-megamenu > a.tapped_once').removeClass('tapped_once')
      }, 150)
    })
  })
}
